module.exports = "/images/vendor/flag-icon-css/flags/1x1/mg.svg?91e10ba084cc7f7b2498ce81f9680a84";